module.exports = __webpack_public_path__ + "img/advance5.080d5661.png";